import { createEffect, createStore } from "effector";

export const $spamDetected = createStore<boolean>(false);
export const setSpamDetected = createEffect(
  async (v: boolean): Promise<boolean> => {
    if (v) {
      const { selectedActivitiesApi } = await import(
        "../selected/selectedActivities"
      );
      await selectedActivitiesApi.cancelAllActivitiesReserve();
      const { selectedPackagesApi } = await import(
        "../selected/selectedPackages"
      );
      await selectedPackagesApi.cancelAllPackagesReserve();
    }
    return v;
  }
);
$spamDetected.on(setSpamDetected, (s, v) => v);
